import CandidateEducationItem, {
  CandidateEducationItemProps,
} from './CandidateEducationItem.container';

export type CandidateEducationItemType = CandidateEducationItemProps;

export default CandidateEducationItem;
